import type { ApiNode } from '@goalbuddy/client';

export interface TreeNode {
  node: ApiNode;
  children: TreeNode[];
}

export function buildTree(nodes: ApiNode[], include: (n: ApiNode) => boolean = () => true): TreeNode[] {
  const byId = new Map<number, TreeNode>();
  for (const n of nodes) if (include(n)) byId.set(n.id, { node: n, children: [] });
  const all = new Map(nodes.map((n) => [n.id, n]));
  /** Nearest included ancestor, so e.g. a project under a result still shows under its goal. */
  const includedAncestor = (n: ApiNode): TreeNode | undefined => {
    let cur = n.parent_id === null ? undefined : all.get(n.parent_id);
    for (let i = 0; cur && i < 64; i++) {
      const hit = byId.get(cur.id);
      if (hit) return hit;
      cur = cur.parent_id === null ? undefined : all.get(cur.parent_id);
    }
    return undefined;
  };
  const roots: TreeNode[] = [];
  for (const t of byId.values()) {
    const parent = includedAncestor(t.node);
    if (parent) parent.children.push(t);
    else roots.push(t);
  }
  const sort = (list: TreeNode[]) => {
    list.sort((a, b) => a.node.sort - b.node.sort || a.node.id - b.node.id);
    list.forEach((c) => sort(c.children));
  };
  sort(roots);
  return roots;
}

export function ancestorsOf(nodes: ApiNode[], id: number): ApiNode[] {
  const byId = new Map(nodes.map((n) => [n.id, n]));
  const out: ApiNode[] = [];
  let cur = byId.get(id);
  while (cur && cur.parent_id !== null && out.length < 64) {
    cur = byId.get(cur.parent_id);
    if (cur) out.unshift(cur);
  }
  return out;
}
